import { FC, createContext } from 'react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import DetectRTC from 'detectrtc';
import { parseLocale } from 'config/Localization';
import { readFromLocalStorage } from '../../services/config/LocalStorage';
import { Token } from '../../models/enums/Token';
import { SECOND_ACCESS_TOKEN_API } from '../../environment/environment';
import { version } from '../../../package.json';

DetectRTC.load(() => {});

const AxiosProvider: FC = ({ children }) => {
    const AxiosContext = createContext('__axiosContext');

    const getAuthorizationToken = () => readFromLocalStorage(Token.TOKEN)?.token;

    const setHeaders = (config: AxiosRequestConfig) => {
        config.headers.Platform = `Web/${DetectRTC.browser.name}/${DetectRTC.browser.fullVersion}/OS:${DetectRTC.osName} ${DetectRTC.osVersion}`;
        config.headers['Platform-Display'] = DetectRTC.displayResolution;
        config.headers['Video-Permission'] = DetectRTC.isWebsiteHasWebcamPermissions;
        config.headers['Microphone-Permission'] = DetectRTC.isWebsiteHasMicrophonePermissions;
        config.headers.Microphone = DetectRTC.hasMicrophone;
        config.headers.Camera = DetectRTC.hasWebcam;
        config.headers.isWebSocketsBlocked = DetectRTC.isWebSocketsBlocked;
        config.headers.isWebSocketsSupported = DetectRTC.isWebSocketsSupported;
        config.headers['Content-Language'] = parseLocale();
        config.headers.Build = version;
    };

    const isTokenExpired = () => {
        const token = readFromLocalStorage(Token.TOKEN);

        return !token?.token;
    };

    axios.defaults.baseURL = process.env.REACT_APP_API;

    // Add a request interceptor
    axios.interceptors.request.use(
        function (config: AxiosRequestConfig) {
            // Do something before request is sent
            if (!isTokenExpired()) {
                config.headers['Access-Token'] = getAuthorizationToken();
            } else {
                config.headers['Access-Token'] = SECOND_ACCESS_TOKEN_API;
            }

            setHeaders(config);

            return config;
        },
        function (error) {
            // Do something with request error
            return Promise.reject(error);
        },
    );

    // Add a response interceptor
    axios.interceptors.response.use(
        function (response): AxiosResponse {
            return response;
        },
        async function (error) {
            const originalRequest = error.config;
            if (error.response?.status === 401 && !originalRequest._retry) {
                // logoutUser();
                // here should be refresh token procedure!!
                // originalRequest._retry = true;
                // const access_token = await refreshAccessToken();
                // if (access_token) do sth... after this logout
                // axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
                // return api(originalRequest);
                // const consumeRefreshToken = useCallback(async () => {
                // const {loginWithRefreshToken} = useAuthenticationService();
                // const tokens: IAuthTokens = await readFromStorage('tokens');
                // return false;
                // return tokens.refresh_token.length && tokens.time_received + tokens.refresh_expires_in < Date.now() && await loginWithRefreshToken(tokens.refresh_token);
                // }, []);
            }
            return Promise.reject(error);
        },
    );

    return <AxiosContext.Provider value="">{children}</AxiosContext.Provider>;
};

export default AxiosProvider;
